// src/hooks/useIdleTimeout.js
import { useEffect, useRef, useCallback } from "react";
import { signOut } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import { auth } from "../services/firebase";

const IDLE_TIMEOUT_MS = 5 * 60 * 1000; // 5 minutes

// Events that count as "activity" and reset the timer
const ACTIVITY_EVENTS = [
  "mousemove",
  "mousedown",
  "keydown",
  "touchstart",
  "scroll",
  "wheel",
  "click",
];

export default function useIdleTimeout() {
  const navigate = useNavigate();
  const timerRef = useRef(null);

  const handleSignOut = useCallback(async () => {
    try {
      await signOut(auth);
    } catch (err) {
      console.error("Idle sign-out error:", err);
    } finally {
      navigate("/", { replace: true });
    }
  }, [navigate]);

  const resetTimer = useCallback(() => {
    if (timerRef.current) clearTimeout(timerRef.current);
    timerRef.current = setTimeout(handleSignOut, IDLE_TIMEOUT_MS);
  }, [handleSignOut]);

  useEffect(() => {
    // Start the timer immediately
    resetTimer();

    // Attach activity listeners
    ACTIVITY_EVENTS.forEach((event) =>
      window.addEventListener(event, resetTimer, { passive: true })
    );

    return () => {
      // Clean up on unmount
      if (timerRef.current) clearTimeout(timerRef.current);
      ACTIVITY_EVENTS.forEach((event) =>
        window.removeEventListener(event, resetTimer)
      );
    };
  }, [resetTimer]);
}
